import { AmountToggleInput as AmountToggleInputType } from '../../../../../types/Survey/Element'
import { AmountToggleInput as AmountToggleInputAnswerType } from '../../../../../types/Survey/Answer/Element'
import { Props } from './types'
import Core from './Core'
import Button from '../../../../UI/Button/Button'
import Dropdown from '../../../../UI/Dropdown/Dropdown'

const AmountToggleInput: React.FC<Props<AmountToggleInputType, AmountToggleInputAnswerType>> = ({
  survey,
  element,
  answer,
  answerElement,
  updateElement,
}) => {
  const set = (prop: keyof AmountToggleInputAnswerType) => (value: any) => {
    updateElement({ ...answerElement, [prop]: value })
  }

  const getOptions = (): number[] => {
    const selectedUnitUUID = answer.organizationUnitUUID
    if (!selectedUnitUUID) return [0]
    const unit = survey.context.organizationUnitList.find((u) => u.uuid === selectedUnitUUID)
    if (!unit) return [0]
    return [0, ...[...new Array(unit.employeeAmount)].map((_, i) => i + 1)]
  }

  return (
    <div>
      <Core element={element} answerElement={answerElement} />
      <div className="flex flex-row gap-10 mt-5">
        <Button contrast={answerElement.isEnabled === true} onClick={() => set('isEnabled')(true)} text={element.yesLabel} />
        <Button contrast={answerElement.isEnabled === false} onClick={() => set('isEnabled')(false)} text={element.noLabel} />
      </div>
      {answerElement.isEnabled && (
        <div className="flex flex-col gap-3 mt-3 w-fit">
          <Dropdown
            items={getOptions().map((o) => ({ value: o, label: `${o.toString()} ${element.amountSuffix}` }))}
            value={answerElement.amount}
            onChange={set('amount')}
            disableSearch
            className="w-fit"
            contentClassName="!w-fit min-w-[242px]"
          />
        </div>
      )}
    </div>
  )
}

export default AmountToggleInput
